/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React from 'react';
import StyledFirebaseAuth from 'react-firebaseui-localized';
import firebase from 'firebase';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Snackbar from '@material-ui/core/Snackbar';
import { Alert } from '@material-ui/lab';
import OutlinedPasswordInput from '../../core/OutlinedPasswordInput';
import Copyright from '../../core/Copyright';
import { useFormStyles } from '../../core/styles';
import { urls } from '../../core/utils/constants';
import { getErrorMessage } from '../../utils/firebaseConfig';

// Configure FirebaseUI.
const uiConfig = {
  // Popup signin flow rather than redirect flow.
  signInFlow: 'popup',
  // We will display Google and Facebook as auth providers.
  signInSuccessUrl: '/',
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
  ],
};

export default function SignInForm() {
  const classes = useFormStyles();

  const [state, setState] = React.useState({
    email: '',
    password: '',
    remember: JSON.parse(localStorage.getItem('saveSession')),
    error: '',
    showError: false,
  });

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const handleCheckboxChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
    localStorage.setItem('saveSession', JSON.stringify(event.target.checked));
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setState({ ...state, showError: false });
  };

  const setError = (translatedError, error) => {
    setState({
      ...state,
      error: translatedError,
      showError: true,
    });
    // eslint-disable-next-line no-console
    console.error(error);
  };

  const signInWithEmailAndPasswordHandler = async (event) => {
    event.preventDefault();
    const { email, password, remember } = state;

    const persistence = remember
      ? firebase.auth.Auth.Persistence.LOCAL
      : firebase.auth.Auth.Persistence.SESSION;

    await firebase.auth().setPersistence(persistence);
    try {
      await firebase.auth().signInWithEmailAndPassword(email, password);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error.code);
      setError(getErrorMessage(error), error.message);
    }
  };

  const { remember, error, showError } = state;

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          ENTRAR
        </Typography>
        <form className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            onChange={handleChange}
            required
            fullWidth
            id="email"
            label="Email"
            name="email"
            type="email"
            value={state.email}
            autoComplete="email"
            autoFocus
          />
          <OutlinedPasswordInput
            id="password"
            name="password"
            label="Senha" 
            onChange={handleChange}
            autoComplete="off"
          />
          <FormControlLabel
            control={
              <Checkbox checked={remember} name="remember" color="primary" onChange={handleCheckboxChange} />
            }
            label="Mantenha-me conectado"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={signInWithEmailAndPasswordHandler}
          >
            ENTRAR
          </Button>
          <Grid container>
            <Grid item xs>
              <Link href={urls.recover.path} variant="body2">
                Esqueceu sua senha?
              </Link>
            </Grid>
            <Grid item />
          </Grid>
        </form>
        <StyledFirebaseAuth lang="pt_br" config={uiConfig} firebase={firebase} auth={firebase.auth()} />
      </div>
      <Box mt={4}>
        <Copyright showImage />
      </Box>
      <Snackbar open={showError} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error">
          {error}
        </Alert>
      </Snackbar>
    </Container>
  );
}
